import {ChangeDetectionStrategy, Component, computed, effect, input, signal} from '@angular/core';
import {VisitorQuestion} from '../../../../../../types/VisitorQuestion';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-cpru-questions',
  templateUrl: './cpru-questions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class CpruQuestionsComponent {
  public careproviderUnitId = input<number>(null);
  public careproviderUnitName = input<string>(null);
  public visitorQuestions = input<VisitorQuestion[]>([]);

  public allQuestionsSorted = computed<VisitorQuestion[]>(() => {
    return this.visitorQuestions().sort((a, b) => {
      if (a.dateCreated > b.dateCreated) {
        return -1;
      }
      if (b.dateCreated > a.dateCreated) {
        return 1;
      }
      return 0;
    });
  });
  public questions = signal<VisitorQuestion[]>([]);
  public showMoreBtn = computed<boolean>(() => this.questions()?.length < this.allQuestionsSorted()?.length);
  private readonly itemsPerPage = 5;

  constructor() {
    dayjs.locale('sv');
    effect(
      () => {
        if (this.allQuestionsSorted().length > 0) {
          this.loadNextItems();
        } else {
          this.questions.set([]);
        }
      },
      {allowSignalWrites: true},
    );
  }

  public moreClick() {
    this.loadNextItems();
  }

  public trackByMethod(i: number, el: VisitorQuestion) {
    return el ? el.id : null;
  }

  private formatDate(date: string): string {
    if (dayjs(date).isValid()) {
      return dayjs(date).format('HH:mm - D MMM, YYYY');
    }
    return date;
  }

  private loadNextItems(): void {
    const currentNextIndex = this.questions().length;
    const currentLastIndex =
      this.allQuestionsSorted().length >= this.questions().length + this.itemsPerPage
        ? currentNextIndex + this.itemsPerPage
        : this.allQuestionsSorted().length;
    for (let i = currentNextIndex; i < currentLastIndex; i++) {
      const questionToAdd = this.allQuestionsSorted()[i];
      questionToAdd.dateCreated = this.formatDate(questionToAdd.dateCreated);
      this.questions.update((prev) => prev.concat(questionToAdd));
    }
  }
}
